import {isFilled} from '@prismicio/client'
import {PrismicRichText} from '@prismicio/react'
import dynamic from 'next/dynamic'
import type {TestimonialsSectionSlicePartnerships} from 'prismicio-types'
import {useState} from 'react'
import {Container} from 'src/common/Container'
import {ContentContainer} from './components/PartnershipsContentContainer'

const CategoryList = dynamic(
  // eslint-disable-next-line boundaries/dependencies -- grandfathered cross-slice import, predates the slice-boundaries rule
  () => import('slices/IntegrationsContainer/CategoryList').then((mod) => mod.CategoryList),
  {
    ssr: false,
  },
)

export const PartnershipsVariant = ({
  slice,
  index: componentIndex,
  pageUid,
}: {
  slice: TestimonialsSectionSlicePartnerships
  index: number
  pageUid: string
}) => {
  const categories = slice.primary.tab.map((tab) => ({
    category_name: tab.category,
  }))

  const [activeTab, setActiveTab] = useState(0)
  const activeTabContent = slice.primary.tab[activeTab]

  return (
    <Container className="py-10 md:py-12" backgroundColor={slice.primary.background_color}>
      <div
        className="mx-auto flex w-full max-w-[1200px] flex-col gap-6 px-5 md:px-10 lg:gap-0 lg:px-5 xl:px-0"
        data-aos="fade-up"
        data-aos-offset="0"
      >
        {isFilled.richText(slice.primary.title) && (
          <PrismicRichText
            field={slice.primary.title}
            components={{
              heading1: ({children}) => (
                <h2 className="text-32 font-medium leading-10 text-moss-black md:text-center">{children}</h2>
              ),
            }}
          />
        )}
        <div className="flex w-full justify-center lg:pb-8 lg:pt-12">
          <CategoryList categories={categories} selectedCategory={activeTab} onClick={setActiveTab} trackingData={{}} />
        </div>
        <ContentContainer
          activeTab={activeTab}
          activeTabContent={activeTabContent}
          componentIndex={componentIndex}
          pageUid={pageUid}
          enableLargeImage={slice.primary.enable_large_image}
          usePrimaryButton={slice.primary.use_primary_button}
        />
      </div>
    </Container>
  )
}
